export default __webpack_public_path__ + "static/media/Parent_Illustrations-04.ed8d1303.svg";